<template lang="pug">
div.image-select-wrap
	div.image-select.type-checkbox(
		v-for="field in fields"
		@click="pickOption(field)"
		:class="classSelected(field.value)"
	)
		span.image
			img(v-if="field.image" :src="field.image")
			img(v-else :src="assetPath + field.value + '.svg'")
		span.name {{ field.title }}


</template>

<script>
	import {onMounted} from "vue";

	export default {
		name: 'ImageSelectCheckbox',

		props: {
			fields: {
				type: Array,
			},
			selected: {
				type: Object,
			},
			assetPath: {
				type: String
			}
		},

		setup(props, {emit}) {

			const classSelected = value => {
				var selected = [];

				props.fields.map((item) => {
					if(item.selected) selected.push(item.value);
				});

				return selected.indexOf(value) >= 0 ? "selected" : '';
			}

			onMounted(() => {
				if (props.selected && props.selected.value) {
					props.fields.map((f) => {
						if (props.selected.value.indexOf(f.value) >= 0) {
							f.selected = true;
						}
					})
				}
			})

			var pickOption = (field) => {
				field.selected = !field.selected;

				var selected = [];

				props.fields.map((item) => {
					if(item.selected) selected.push(item.value);
				});

				var value = Object.assign({}, field, {
					value: selected
				})

				emit('select', value);
			}

			return {
				pickOption,
				classSelected
			}
		}
	}
</script>
